// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import categoryListingStyles from "@steiner/App/SharedStyles/CategoryListingStyles";
import { categoryDetailSubCategoriesStyles } from "@steiner/Overrides/Widgets/Category/CategoryDetailSubCategories";
import { ellipsis } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

categoryDetailSubCategoriesStyles.container = {
    ...categoryListingStyles.container,
};

categoryDetailSubCategoriesStyles.innerContainer = {
    gap: 12,
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    ...categoryListingStyles.rightBorderedCategoryListItem,
};

categoryDetailSubCategoriesStyles.subCategoryImageClickable = {
    css: css`
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    `,
};

categoryDetailSubCategoriesStyles.subCategoryImageItem = { width: 12 };

categoryDetailSubCategoriesStyles.subCategoryImage = {
    width: "124px",
    height: "124px",
    css: css`
        img {
            aspect-ratio: 1 / 1;
        }
    `,
};

categoryDetailSubCategoriesStyles.subCategoryNameLinkItem = {
    width: 12,
    css: css`
        justify-content: center;
    `,
};
categoryDetailSubCategoriesStyles.subCategoryNameLink = {
    color: "primary",
    typographyProps: {
        size: "14px",
    },
    css: css`
        flex-grow: 1;
        margin-top: 12px;
        text-align: center;
        ${ellipsis(3)}
    `,
};
